/**
 * Credit System - Single Source of Truth
 *
 * All credit <-> USD conversion MUST go through these utilities.
 * Keep in sync with auth/src/utils/credits.ts
 *
 * 1 USD = 1,000 credits
 * 1 credit = $0.001 (0.1 cent)
 */

export const CREDITS_PER_USD = 1000;

/**
 * Low balance threshold in credits.
 * Users with balance at or below this are shown warnings.
 * Default: 500 credits = $0.50
 */
export const LOW_BALANCE_THRESHOLD_CREDITS = 500;

/**
 * Convert credits to USD.
 */
export function creditsToUsd(credits: number): number {
  return credits / CREDITS_PER_USD;
}

/**
 * Convert USD to credits (rounded to nearest integer).
 */
export function usdToCredits(usd: number): number {
  return Math.round(usd * CREDITS_PER_USD);
}

/**
 * Format credits as a USD string (e.g., "$5.00").
 */
export function formatCreditsAsUsd(credits: number | null): string {
  if (credits === null) return '—';
  return `$${creditsToUsd(credits).toFixed(2)}`;
}

/**
 * Format credits for display (e.g., "500 credits").
 */
export function formatCredits(credits: number): string {
  return `${credits.toLocaleString()} credits`;
}

/**
 * Check if a balance is considered low.
 */
export function isLowBalance(credits: number): boolean {
  return credits <= LOW_BALANCE_THRESHOLD_CREDITS;
}





